import React from 'react';
import {
  Box,
  ButtonBase, LinearProgress,
  makeStyles, Paper, Typography,
} from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';

import { FormattedMessage, useIntl } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { servicesIconsCodes } from '../../config/config';
import { isLoadingTherapistServicesState } from '../../state/apiRequestStatus';
import { selectedServiceIdState, selectedTherapistState } from '../../state/selected';
import { servicesState } from '../../state/apiData';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  services: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    [theme.breakpoints.up('sm')]: {},
  },
  serviceWrapper: {
    flex: '0 0 48%',
    minHeight: 1,
    [theme.breakpoints.up('sm')]: {
      flex: '0 0 31%',
    },
  },
  serviceWrapperDummy: {},
  service: {
    height: 0,
    paddingTop: '95%',
    position: 'relative',
  },
  serviceInner: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    display: 'block',
  },
  logoWrapper: {},
  logo: {},
  serviceTitle: {
    marginTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  searchIconButton: {
    padding: 10,
  },
}));

const SelectService = () => {
  const classes = useStyles();
  const intl = useIntl();

  const setSelectedServiceId = useSetRecoilState(selectedServiceIdState);
  const isLoadingTherapistServices = useRecoilValue(isLoadingTherapistServicesState);
  const selectedTherapist = useRecoilValue(selectedTherapistState);
  const services = useRecoilValue(servicesState);

  const renderServicesList = () => {
    if (isLoadingTherapistServices) {
      return (
        <Box mt={3}>
          <Typography>
            <FormattedMessage id="SelectService.infoFilteringServices" />
          </Typography>
          <Box mt={2}>
            <LinearProgress />
          </Box>
        </Box>
      );
    }

    let filteredServices = services;

    if (selectedTherapist) {
      if (!(selectedTherapist.services && selectedTherapist.services.length > 0)) {
        return (
          <Box mt={3}>
            <Alert severity="error">
              <FormattedMessage id="SelectService.errorNoService" />
            </Alert>
          </Box>
        );
      }

      const availableServicesIds = selectedTherapist.services.filter(
        (srv) => srv.isFirstAppointment === true,
      )
        .map((s) => s.disciplineID);

      filteredServices = services.filter(
        (serv) => availableServicesIds.includes(serv.externalTherapyID),
      );
    }

    return (
      <div className={classes.services}>
        {filteredServices.map((service) => (
          <Paper
            className={classes.serviceWrapper}
            component="form"
            key={service.externalTherapyID}
          >
            <div
              className={classes.service}
            >
              <ButtonBase
                className={classes.serviceInner}
                onClick={() => {
                  if (window && window.gtag) {
                    window.gtag('event', 'search', (selectedTherapist ? {
                      search_term: `${selectedTherapist.name} / ${service.therapyName.en}`,
                      search_type: 'Professional / Category',
                      search_lang: intl.locale,
                    } : {
                      search_term: service.therapyName.en,
                      search_type: 'Category',
                      search_lang: intl.locale,
                    }));
                  }

                  setSelectedServiceId(service.externalTherapyID);
                }}
              >
                <div className={classes.logoWrapper}>
                  {servicesIconsCodes.includes(service.therapyCode)
                    ? (
                      <img
                        className={classes.logo}
                        src={`/static/images/services/${service.therapyCode}.svg`}
                        alt=""
                      />
                    )
                    : <FileCopy />}
                </div>
                <Typography
                  className={classes.serviceTitle}
                  variant="body2"
                  component="div"
                >
                  {service.therapyName[intl.locale]}
                </Typography>
              </ButtonBase>
            </div>
          </Paper>
        ))}
        <div className={`${classes.serviceWrapper} ${classes.serviceWrapperDummy}`} />
        <div className={`${classes.serviceWrapper} ${classes.serviceWrapperDummy}`} />
        <div className={`${classes.serviceWrapper} ${classes.serviceWrapperDummy}`} />
      </div>
    );
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="h6">
        <FormattedMessage id="SelectCategory.title" />
      </Typography>
      {renderServicesList()}
    </div>
  );
};

SelectService.propTypes = {};

export default SelectService;
